import { Transform, TransformFnParams } from 'class-transformer';

export function YesNoToBoolean() {
  return Transform(({ value }: TransformFnParams) => (value === 'Yes' ? true : value === 'No' ? false : value));
}
